module.exports = __webpack_public_path__ + "img/intensity-indicator-advanced.1ec0d0a6.svg";